var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M32.356 10.926h-2.1V7.779l-4.331-.066.023 3.214H12.936l.089-3.214-4.241.066v3.214l-2.143-.066A2.144 2.144 0 0 0 4.5 13.069v15a2.144 2.144 0 0 0 2.143 2.143h25.713a2.144 2.144 0 0 0 2.144-2.143v-15a2.144 2.144 0 0 0-2.144-2.143zM27 8.784h2.143v4.286H27zm-13.929 7.3c1.294 0 2.344 1.379 2.344 3.08s-1.05 3.08-2.344 3.08-2.344-1.379-2.344-3.08 1.05-3.08 2.344-3.08zm-3.214-7.3H12v4.286H9.856zM8.428 25.871s.254-2.038.831-2.422a8.217 8.217 0 0 1 2.239-.641s1.078 1.152 1.536 1.152 1.535-1.152 1.535-1.152a8.192 8.192 0 0 1 2.24.641c.678.452.847 2.422.847 2.422H8.428zm21.785-1.016H20.57v-1.071h9.643zm0-2.143H20.57v-1.071h9.643zm0-2.143H20.57V19.5h9.643zm0-2.143H20.57v-1.071h9.643z",
    transform: "translate(-4.499 -7.712)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8c1d6ed3b493af1daf25291248a63427.svg";
export { ForwardRef as ReactComponent };